/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingpublished1Inputs */

const en_listingpublished1 = /** @type {(inputs: Listingpublished1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing published`)
};

const de_listingpublished1 = /** @type {(inputs: Listingpublished1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort veröffentlicht`)
};

/**
* | output |
* | --- |
* | "Listing published" |
*
* @param {Listingpublished1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingpublished1 = /** @type {((inputs?: Listingpublished1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingpublished1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingpublished1(inputs)
	return de_listingpublished1(inputs)
});
export { listingpublished1 as "listingPublished" }